import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { formatarMoeda } from "../../Apuracoes/Detalhe/utils/agregarPorConta.util";
import { formatarDataHora } from "../utils/projeto.util";

const CONFIG = {
  enviar: { titulo: "Enviar Projeto ao Cliente", confirmar: "Enviar", executando: "Enviando…", cor: "#18316e" },
  liberar: { titulo: "Liberar Prévia", confirmar: "Liberar", executando: "Liberando…", cor: "#ef6c00" },
  cancelar: {
    titulo: "Cancelar Projeto",
    confirmar: "Confirmar Cancelamento",
    executando: "Cancelando…",
    cor: "#c62828",
  },
  aprovar: { titulo: "Aprovar Projeto", confirmar: "Aprovar", executando: "Aprovando…", cor: "#2e7d32" },
};

function CorpoDaAcao({ acao, projeto }) {
  switch (acao) {
    case "enviar":
      return (
        <>
          <Typography>
            Você está prestes a enviar o projeto {projeto.codigo} para aprovação do cliente.
          </Typography>
          <Alert severity="warning" sx={{ mt: 2 }}>
            <strong>Atenção:</strong> após o envio, o projeto ficará aguardando aprovação e não será
            possível editá-lo até que seja aprovado, cancelado ou liberado.
          </Alert>
        </>
      );
    case "liberar":
      return (
        <Typography>
          O projeto {projeto.codigo} voltará para Em Prévia e poderá ser atualizado, sobrescrito ou
          enviado novamente.
        </Typography>
      );
    case "cancelar":
      return (
        <Typography>
          O cliente não aprovou este projeto. Ao confirmar, o projeto {projeto.codigo} será marcado
          como Cancelado e poderá ser reenviado.
        </Typography>
      );
    case "aprovar":
      return (
        <>
          <Typography>Valores processados em {formatarDataHora(projeto.dataProcessamento)}</Typography>
          {projeto.apuracaoDesatualizada && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              <strong>A apuração foi reprocessada depois deste cálculo</strong>, então os valores
              podem estar desatualizados. Libere a prévia, atualize os valores e envie novamente.
            </Alert>
          )}
          <Typography sx={{ mt: 2 }}>
            {formatarMoeda(projeto.valorTotal)} será registrado como crédito aprovado na Conta
            Corrente.
          </Typography>
          <Alert severity="error" sx={{ mt: 2 }}>
            A aprovação é definitiva: depois de aprovado, o projeto não volta para edição e os itens
            passam a constar como utilizados nas apurações.
          </Alert>
        </>
      );
    default:
      return null;
  }
}

/**
 * TXM-558 — confirmação das ações do Resumo do Projeto que mudam o status (enviar, liberar,
 * cancelar, aprovar). "Atualizar valores" e "Reenviar créditos" executam direto, sem este modal.
 */
export default function ModalAcaoProjeto({ open, acao, projeto, executando, onConfirmar, onClose }) {
  const config = acao ? CONFIG[acao] : null;
  if (!config || !projeto) return null;

  return (
    <Dialog open={open} onClose={executando ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ color: config.cor, fontWeight: 700 }}>{config.titulo}</DialogTitle>
      <DialogContent>
        <CorpoDaAcao acao={acao} projeto={projeto} />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={executando} sx={{ textTransform: "none" }}>
          Voltar
        </Button>
        <Button
          onClick={onConfirmar}
          disabled={executando}
          variant="contained"
          sx={{ textTransform: "none", fontWeight: 600, bgcolor: config.cor, "&:hover": { bgcolor: config.cor } }}
        >
          {executando ? config.executando : config.confirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
